import React, {FC} from 'react';
import styled from 'styled-components';

import {OkCancelDialog} from '../../../../../../../src/components/common/dialogs/okCancelDialog';
import {getNameForCard} from '../../../../../../../src/helpers/models/cardHelpers';
import {CardModel} from '../../../../../../../src/models/api/cardModel';
import {Plural, Trans} from '../../../../../../shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../../../shared/ui/src/components/buttons/buttonConstants';

/*
 * Props.
 */

interface DeleteMultipleCardsConfirmationDialogProps {
  cards: ReadonlyArray<CardModel>;
  onClose: Handler;
  onDelete: Handler;
}

/*
 * Styles.
 */

const StyledOkCancelDialog = styled(OkCancelDialog)`
  margin: 0 16px;
`;

/*
 * Component.
 */

export const DeleteMultipleCardsConfirmationDialog: FC<DeleteMultipleCardsConfirmationDialogProps> = (
  props,
) => {
  const {cards, onClose, onDelete} = props;
  return (
    <StyledOkCancelDialog
      title={
        <Plural
          id="delete-contacts-confirmation-dialog-title"
          value={cards.length}
          one={`Delete ${getNameForCard(cards[0]) ?? ''}`}
          other="Delete # contacts"
        />
      }
      okButtonLabel={
        <Trans id="delete-contacts-confirmation-dialog-delete-permanently">Delete permanently</Trans>
      }
      okButtonVariant={ButtonVariantsEnum.DANGER}
      onRequestClose={onClose}
      onOkClick={onDelete}
    >
      <Trans id="delete-contacts-confirmation-dialog-permanent-delete-warning">
        This action cannot be undone.
      </Trans>
    </StyledOkCancelDialog>
  );
};
